import { render, staticRenderFns } from "./CurrencyCollapse.vue?vue&type=template&id=00114fb9&scoped=true&"
import script from "./CurrencyCollapse.vue?vue&type=script&lang=js&"
export * from "./CurrencyCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00114fb9",
  null
  
)

export default component.exports